module.exports = __webpack_public_path__ + "media/ets/9-f55a0316.png";